import type { Order } from '../models';

/**
 * Prioridad de packing: agrupa pedidos del mismo courier (courier_id ascendente).
 * Pedidos sin courier_id van al final. Desempate estable por id.
 */
export function sortOrdersByCourierThenId(orders: Order[]): Order[] {
  const courierRank = (id: number | null | undefined) =>
    id == null || Number.isNaN(Number(id)) ? Number.POSITIVE_INFINITY : Number(id);

  return [...orders].sort((a, b) => {
    const byCourier = courierRank(a.shipment?.courier_id) - courierRank(b.shipment?.courier_id);
    if (byCourier !== 0) return byCourier;
    return a.id - b.id;
  });
}
